<template>
  <div>
    <CRow>
      <CCol sm="12">
        <ExecutivesTable
          :items="executives"
          hover
          striped
          border
          small
          fixed
          caption="Gerentes"
          @refresh="refreshItems"
          :permissions="permissions"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import ExecutivesTable from '../../components/executives/ExecutivesTable.vue'
import ws from '../../services/executives';
import account_ws from '../../services/account';
import store from '../../store'

export default {
  name: 'Executives',
  components: { ExecutivesTable },
  data: function () {
		return {
            executives: [],
            permissions: null
        }
  },
  mounted: async function() {
    this.loading();
    let response = await ws.get();

    if(response.type == "success"){
      this.executives = response.data;
    }

    let response2 = await account_ws.getInfo(); 

    if(response2.type == "success"){
      this.permissions = response2.data.user.permissions;
    }

    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      this.executives = await items;
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
